var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "94px",
    height: "48px",
    viewBox: "0 0 94 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#ADADAD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,48 C34.208,48 36,46.208 36,44 L36,4 C36,1.792 34.208,0 32,0 L4,0 C1.792,0 0,1.792 0,4 L0,44 C0,46.208 1.792,48 4,48 L32,48 Z M4,42 L4,6 L32,6 L32,42 L4,42 Z M17,45 C17,44.448 17.448,44 18,44 C18.552,44 19,44.448 19,45 C19,45.552 18.552,46 18,46 C17.448,46 17,45.552 17,45 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,48 C86.208,48 88,46.208 88,44 L88,4 C88,1.792 86.208,0 84,0 L56,0 C53.792,0 52,1.792 52,4 L52,44 C52,46.208 53.792,48 56,48 L84,48 Z M56,42 L56,6 L84,6 L84,42 L56,42 Z M69,45 C69,44.448 69.448,44 70,44 C70.552,44 71,44.448 71,45 C71,45.552 70.552,46 70,46 C69.448,46 69,45.552 69,45 Z",
    id: "Shape-Copy-2",
    transform: "translate(70.000000, 24.000000) rotate(-90.000000) translate(-70.000000, -24.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletPreview);
export default __webpack_public_path__ + "static/media/TabletPreview.1c9e1de8.svg";
export { ForwardRef as ReactComponent };